import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#074960',
            light: '#5c7fc8',
            dark: '#1a3a72',
            contrastText: '#fff'
        },
        secondary: {
            main: '#ffffff',
            contrastText: '#074960'
        },
        background: {
            default: '#f4f6f9',
            paper: '#ffffff'
        },
        text: {
            primary: '#1e2a3b',
            secondary: '#6b7a90'
        },
        success: { main: '#2e7d32' },
        warning: { main: '#ed6c02' },
        error: { main: '#d32f2f' },
        info: { main: '#0288d1' }
    },
    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: { fontWeight: 700, fontSize: '2.2rem' },
        h2: { fontWeight: 700, fontSize: '1.8rem' },
        h3: { fontWeight: 600, fontSize: '1.5rem' },
        h4: { fontWeight: 600, fontSize: '1.25rem' },
        h5: { fontWeight: 600, fontSize: '1.1rem' },
        h6: { fontWeight: 600, fontSize: '1rem' },
        button: { textTransform: 'none', fontWeight: 600 }
    },
    shape: { borderRadius: 8 },
    components: {
        MuiButton: {
            styleOverrides: {
                root: { borderRadius: 8, padding: '8px 20px' },
                containedPrimary: { boxShadow: '0 2px 8px rgba(43,87,158,0.3)', '&:hover': { boxShadow: '0 4px 12px rgba(43,87,158,0.4)' } }
            }
        },
        MuiCard: {
            styleOverrides: { root: { borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.08)' } }
        },
        MuiPaper: {
            styleOverrides: { root: { borderRadius: 12 } }
        },
        MuiTextField: {
            defaultProps: { variant: 'outlined', size: 'small' }
        },
        MuiTableHead: {
            styleOverrides: { root: { '& .MuiTableCell-head': { backgroundColor: '#074960', color: '#fff', fontWeight: 600 } } }
        },
        MuiChip: {
            styleOverrides: { root: { borderRadius: 6 } }
        }
    }
});

export default theme;
